"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var renderItems = function renderItems(children, childClassName, firstChildClassName, lastChildClassName) {
  return _react.Children.map(children, function (child, i) {
    if (child == null) {
      return null;
    }

    var computedChildClassName;

    if (i === 0 && firstChildClassName != null) {
      computedChildClassName = firstChildClassName;
    } else if (!children.hasOwnProperty(i + 1) && lastChildClassName != null) {
      computedChildClassName = lastChildClassName;
    } else {
      computedChildClassName = childClassName;
    }

    var className = (0, _classnames.default)('uiListItem', 'private-list__item', computedChildClassName);
    return _react.default.createElement("li", {
      className: className
    }, child);
  });
};

var UIList = (0, _react.forwardRef)(function (props, ref) {
  var ordered = props.ordered,
      styled = props.styled,
      inline = props.inline,
      className = props.className,
      children = props.children,
      childClassName = props.childClassName,
      firstChildClassName = props.firstChildClassName,
      lastChildClassName = props.lastChildClassName,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["ordered", "styled", "inline", "className", "children", "childClassName", "firstChildClassName", "lastChildClassName", "use"]);
  var computedClassName = (0, _classnames.default)('uiList', {
    'private-list--inline': inline || use === 'inline-divided',
    'private-list--inline-divided': use === 'inline-divided',
    'private-list--unstyled': !styled
  }, className);
  var renderedItems = renderItems(children, childClassName, firstChildClassName, lastChildClassName);
  var List = ordered ? 'ol' : 'ul';
  return _react.default.createElement(List, Object.assign({}, rest, {
    className: computedClassName,
    ref: ref
  }), renderedItems);
});
UIList.propTypes = {
  childClassName: _propTypes.default.string,
  children: _propTypes.default.node,
  firstChildClassName: _propTypes.default.string,
  inline: _propTypes.default.bool.isRequired,
  lastChildClassName: _propTypes.default.string,
  ordered: _propTypes.default.bool.isRequired,
  styled: _propTypes.default.bool.isRequired,
  use: _propTypes.default.oneOf(['default', 'inline-divided'])
};
UIList.defaultProps = {
  inline: false,
  ordered: false,
  styled: false,
  childClassName: '',
  use: 'default'
};
UIList.displayName = 'UIList';
var _default = UIList;
exports.default = _default;
module.exports = exports.default;